<template>
  <fragment>
    <MobileHeaderBar
      v-if="$store.state.isLandscape && $store.state.isMobile"
      :customStyle="{ display: 'flex' }"
    />
    <div class="about">
      <div class="about-info">
        <div class="title">About 12 Sunsets</div>
        <div class="grow">
          <div class="about-text">
            <section>
              <p>
                Originally captured as the medium for Ed Ruscha’s creative work,
                the more than 65,000 photographs selected from this archive
                present a unique view of one of Los Angeles’ quintessential
                streets, Sunset Boulevard, and how it has changed over the past
                50 years. Ed Ruscha, with help from Getty and Stamen Design, is
                making this amazing collection accessible to you: explore his
                images of Sunset and discover your own story of Los Angeles.
              </p>
            </section>
            <section>
              <p>
                You can learn more about Ed Ruscha, and his archives at the
                Getty Research Institute’s
                <a
                  href="https://www.getty.edu/research/special_collections/notable/ruscha.html"
                  >website</a
                >.
              </p>
              <p>
                The images were tagged using artificial intelligence. They are
                sometimes puzzling but always interesting. You can learn more
                about the process of creating them at
                <a href="https://www.getty.edu/news/does-it-snow-in-la/"
                  >Getty’s website</a
                >.
              </p>
              <div class="buttonrow">
                <a
                  class="button"
                  href="https://www.getty.edu/research/special_collections/notable/ruscha.html"
                  >VIEW ARCHIVE PAGE</a
                >
              </div>
            </section>
          </div>
        </div>
      </div>
      <div v-if="!$store.state.isMobile" class="legal">
        <Footer />
      </div>
      <ShareModal v-if="$store.state.ui.share" terminology="Project" />
    </div>
  </fragment>
</template>

<script>
import Footer from "../components/Footer";
import MobileHeaderBar from "../components/MobileHeaderBar";
import ShareModal from "../components/ShareModal";

export default {
  name: "About",
  components: {
    ShareModal,
    Footer,
    MobileHeaderBar
  }
};
</script>

<style lang="scss" scoped>
@import "@/constants/_variables.scss";

.about {
  background-image: url("../assets/about-bg.jpg");
  min-height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media (max-width: 815px) and (orientation: landscape) {
    min-height: calc(100% - 67px);
  }
}

.about-info {
  max-width: 1180px;
  width: 90%;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.about-text {
  flex-grow: 1;
  font-size: 15px;
  justify-content: space-between;
  line-height: 26px;
  padding: 30px 120px;
  text-align: left;
  display: flex;
  padding-top: 0px;

  section {
    flex-basis: 48%;
  }

  a {
    color: black;
  }

  @media (max-width: 815px) {
    font-size: 14px;
    padding-left: 1em;
    padding-right: 1em;
    display: block;
  }
}

p {
  font-family: "Graphik", "Open Sans", sans-serif;
  margin-right: 2em;
}

.title {
  text-align: left;
  width: 100%;
  font-size: 50px;
  font-weight: 500;
  font-style: italic;
  background-color: $copper;
  color: White;
  text-transform: uppercase;
  line-height: 0.7;
  padding-top: 50px;
  padding-left: 40px;

  @media (max-width: 815px) {
    font-size: 24px;
    padding-left: 14px;
    padding-top: 20px;
  }
}

.legal {
  text-align: left;
  font-size: 15px;
  color: white;
  background-color: black;
  position: absolute;
  bottom: 0;
  width: 100%;
}

.buttonrow {
  text-align: left;
  margin-top: 2rem;

  .button {
    color: white;
    text-decoration: none;

    &:hover {
      color: $copper;
    }
  }

  @media (max-width: 815px) {
    padding-left: 1em;
    padding-right: 1em;
  }
}

.grow {
  flex-grow: 1;
  overflow-y: auto;
  max-height: calc(100vh - 150px);
}
</style>
